'use strict';

import Api from 'services/api';


var ReportsActionCreators = {

    getLeaveHistoryReport(model) {
        Api.REPORTS.getLeaveHistoryReport(model);
    },
    getLeaveHistoryByDateRangeReport(model) {
        Api.REPORTS.getLeaveHistoryByDateRangeReport(model);
    },
    getLeaveBalanceReport(model) {
        Api.REPORTS.getLeaveBalanceReport(model);
    },
    getMedicalAndEmergencyReport(model) {
        Api.REPORTS.getMedicalAndEmergencyReport(model);
    },
    getPersonalChangesAuditReport(model) {
        Api.REPORTS.getPersonalChangesAuditReport(model);
    },
    getLeaveAuditReport(model) {
        Api.REPORTS.getLeaveAuditReport(model);
    },
    getMaintenanceAuditReport(model) {
        Api.REPORTS.getMaintenanceAuditReport(model);
    },
    getActivationReport(model) {
        Api.REPORTS.getActivationReport(model);
    },
    getTeamsReport(model) {
        Api.REPORTS.getTeamsReport(model);
    },
    getAllRolesReport(model) {
        Api.REPORTS.getAllRolesReport(model);
    },
    getSingleRoleReport(roleId, model) {
        Api.REPORTS.getSingleRoleReport(roleId, model);
    },
    getRolesByRoleTypeReport(roleTypeId, model) {
        Api.REPORTS.getRolesByRoleTypeReport(roleTypeId, model);
    },
};

export default ReportsActionCreators; 
